// Script to add your admin credentials to Firebase
import {
    collection,
    addDoc,
    serverTimestamp,
    query,
    where,
    getDocs
} from 'firebase/firestore';
import { db } from '../firebase';

export const addAdminCredentials = async (username, password, name = "Super Admin", email = "") => {
    try {

        // First check if admin already exists
        const adminQuery = query(
            collection(db, 'admins'),
            where('username', '==', username)
        );
        const adminSnapshot = await getDocs(adminQuery);

        if (!adminSnapshot.empty) {
            return {
                success: false,
                error: 'Admin with this username already exists'
            };
        }

        // Add admin credentials
        const adminData = {
            username: username,
            password: password,
            name: name,
            email: email,
            createdDate: serverTimestamp(),
            lastLogin: null,
            isActive: true
        };

        const adminRef = await addDoc(collection(db, 'admins'), adminData);

        return {
            success: true,
            id: adminRef.id,
            admin: { ...adminData, id: adminRef.id }
        };

    } catch (error) {
        console.error('❌ Error adding admin credentials:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

// If running directly in browser console
if (typeof window !== 'undefined') {
    window.addAdminCredentials = addAdminCredentials;
}
